import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import { formatDate } from "~/utils/format";
import Icon from "../Icon";
import Tag from "../Tag";
import styles from "./Card.module.scss";

interface CardProps {
  href: string;
  name: string;
  thumbnail: string;
  showIconPlay?: boolean;
  time: string;
  variant?: "primary" | "secondary";
  className?: string;
  tags?: string[];
}

const Card: FC<CardProps> = ({
  name,
  href,
  thumbnail,
  showIconPlay = false,
  variant = "primary",
  time,
  className,
  tags,
}) => {
  const { i18n } = useTranslation();

  return (
    <Link
      href={href}
      className={classNames(styles.card, styles[variant], className)}
      aria-label={name}
    >
      <div className={styles.image}>
        <Image src={thumbnail || "/images/card_default.png"} alt={name} fill />

        {showIconPlay && (
          <div className={styles.icon_overlay}>
            <Icon
              name="play"
              color="#FFFFFF"
              className={styles.icon}
              size={20}
            />
          </div>
        )}
      </div>

      <div className={styles.card_info}>
        {tags?.length ? (
          <div className={styles.tag_list}>
            {tags?.map((t) => (
              <Tag name={t} key={t} />
            ))}
          </div>
        ) : null}
        <h3 className={classNames(styles.name, "line-clamp-2")}>{name}</h3>
        {time && (
          <p className={styles.time}>
            {formatDate(new Date(time), "LLL dd yyyy", i18n.language)}
          </p>
        )}
      </div>
    </Link>
  );
};

export default Card;
